// Datenschutzerklärung, Text wörtlich vom Kunden übernommen (Stand: Oktober 2026).
// Abschnitt: { h, sub?: true, items: [string | string[]] } – string = Absatz, string[] = Liste.
export const DATENSCHUTZ = {
  intro: ["Schwimmschule Manta", "Stand: Oktober 2026"],
  sections: [
    {
      h: "1. Datenschutz auf einen Blick",
      items: [
        "Der Schutz deiner personenbezogenen Daten ist uns wichtig. Wir verarbeiten personenbezogene Daten vertraulich und entsprechend den geltenden Datenschutzvorschriften, insbesondere der Datenschutz-Grundverordnung (DSGVO).",
        "Diese Datenschutzerklärung informiert darüber, welche personenbezogenen Daten wir auf unserer Website, bei der Buchung unserer Schwimmkurse über YOLAWO und bei der Nutzung unserer Eltern-App verarbeiten, zu welchen Zwecken dies geschieht und welche Rechte dir zustehen.",
      ],
    },
    {
      h: "2. Verantwortliche Stelle",
      items: [
        "Verantwortlich für die Verarbeitung personenbezogener Daten ist:",
        "Schwimmschule Manta\nInhaberin: Melissa Siebenlist\nE-Mail: info@schwimmschulemanta.de\nWebsite: https://schwimmschulemanta.de",
      ],
    },
    {
      h: "3. Welche personenbezogenen Daten verarbeiten wir?",
      items: [
        "Wir verarbeiten personenbezogene Daten, soweit dies für die Bereitstellung unserer Leistungen, die Bearbeitung von Anfragen sowie die Organisation und Durchführung unserer Schwimmkurse erforderlich ist.",
        "Hierzu können insbesondere gehören:",
        [
          "Namen und Kontaktdaten der Erziehungsberechtigten",
          "Name und Geburtsdatum beziehungsweise Alter des Kindes",
          "E-Mail-Adresse und gegebenenfalls Telefonnummer",
          "Angaben zu gebuchten Schwimmkursen und Kursterminen",
          "Anwesenheit und Teilnahme an einzelnen Kurseinheiten",
          "Lernfortschritte, Schwimmfähigkeiten und erreichte Schwimmabzeichen",
          "Hinweise zu Fähigkeiten, die noch geübt werden sollen",
          "Nachrichten und Mitteilungen im Zusammenhang mit dem Schwimmkurs",
          "Benutzerkonto- und Anmeldedaten für die Eltern-App",
          "Informationen zum Zahlungsstatus einer Kursbuchung",
          "gegebenenfalls gesundheitsbezogene Angaben, sofern diese für die sichere Teilnahme am Schwimmkurs relevant sind.",
        ],
        "Wir verarbeiten nur solche Daten, die für den jeweiligen Zweck erforderlich sind oder für deren Verarbeitung eine andere geeignete Rechtsgrundlage besteht.",
        "Soweit die Verarbeitung zur Durchführung vorvertraglicher Maßnahmen oder zur Erfüllung eines Vertrags erforderlich ist, erfolgt sie auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Weitere Rechtsgrundlagen können insbesondere gesetzliche Verpflichtungen nach Art. 6 Abs. 1 lit. c DSGVO oder berechtigte Interessen nach Art. 6 Abs. 1 lit. f DSGVO sein, sofern deren Voraussetzungen vorliegen.",
      ],
    },
    {
      h: "4. Online-Buchungen und Kursanmeldungen über YOLAWO",
      items: [
        "Für die Buchung und Anmeldung zu unseren Schwimmkursen verwenden wir das Buchungssystem YOLAWO.",
        "Die Buchungen und Anmeldungen erfolgen über das auf unserer Website bereitgestellte YOLAWO-Buchungssystem.",
      ],
    },
    {
      h: "4.1 Verarbeitete Daten",
      sub: true,
      items: [
        "Bei einer Kursbuchung können insbesondere folgende Daten verarbeitet werden:",
        [
          "Name und Kontaktdaten der Erziehungsberechtigten",
          "Name und gegebenenfalls Geburtsdatum des teilnehmenden Kindes",
          "E-Mail-Adresse und gegebenenfalls Telefonnummer",
          "ausgewählter Schwimmkurs und gebuchte Termine",
          "Angaben, die für die Organisation und Durchführung des Kurses erforderlich sind",
          "gegebenenfalls Angaben zur Zahlung, soweit diese über das Buchungssystem abgewickelt wird.",
        ],
        "Welche Angaben konkret erhoben werden, richtet sich nach den jeweiligen Feldern und Funktionen des Buchungsprozesses.",
      ],
    },
    {
      h: "4.2 Zweck und Rechtsgrundlage",
      sub: true,
      items: [
        "Die Verarbeitung erfolgt zur Bearbeitung der Anmeldung, zur Verwaltung der Buchung, zur Kommunikation mit den Erziehungsberechtigten sowie zur Organisation und Durchführung des gebuchten Schwimmkurses.",
        "Rechtsgrundlage für die erforderliche Verarbeitung ist Art. 6 Abs. 1 lit. b DSGVO.",
      ],
    },
    {
      h: "4.3 Technische Einbindung und Dienstleister",
      sub: true,
      items: [
        "Bei der Nutzung des YOLAWO-Buchungssystems werden personenbezogene Daten an YOLAWO übermittelt, soweit dies für die Bereitstellung und Durchführung der Buchungsfunktion erforderlich ist.",
        "Nach den Angaben von YOLAWO verarbeitet der Anbieter die Teilnehmerdaten als Auftragsverarbeiter. YOLAWO stellt außerdem Informationen zu seinem Hosting und zu seinem Auftragsverarbeitungsvertrag bereit.",
        "Weitere Informationen findest du in der Datenschutzerklärung von YOLAWO:\nhttps://yolawo.de/datenschutz/",
        "Informationen zum Datenschutz und zur Auftragsverarbeitung:\nhttps://support.yolawo.de/de/articles/4508410-wie-ist-der-datenschutz-bei-yolawo-geregelt",
      ],
    },
    {
      h: "5. Eltern-App zur Verwaltung der Kinderprofile und Schwimmfortschritte",
      items: [
        "Wir stellen Erziehungsberechtigten eine Eltern-App zur Verfügung. Über diese App können sie Informationen zu den ihnen zugeordneten Kindern, deren Kursen und deren Schwimmfortschritt einsehen.",
        "Die App wurde mithilfe der Entwicklungsplattform Emergent erstellt.",
      ],
    },
    {
      h: "5.1 Verarbeitete Daten in der Eltern-App",
      sub: true,
      items: [
        "Im Rahmen der Nutzung der App können insbesondere folgende personenbezogene Daten verarbeitet und gespeichert werden:",
        [
          "Stammdaten des Kindes, insbesondere Name und gegebenenfalls Geburtsdatum",
          "Zuordnung des Kindes zu einem Elternkonto",
          "Name und E-Mail-Adresse des jeweiligen Elternteils beziehungsweise Erziehungsberechtigten",
          "Benutzerkonto- und Anmeldedaten",
          "Angaben zu gebuchten Kursen und einzelnen Kursterminen",
          "Teilnahme und Anwesenheit bei einzelnen Kurseinheiten",
          "dokumentierter Schwimmfortschritt und erreichte Schwimmabzeichen",
          "Fähigkeiten, die noch geübt werden sollen",
          "Fortschrittsnotizen der Schwimmlehrkräfte",
          "Nachrichten und Mitteilungen zwischen der Schwimmschule und den Erziehungsberechtigten",
          "Informationen zum Zahlungsstatus eines Kurses.",
        ],
        "Die tatsächlich verarbeiteten Daten richten sich nach den in der App aktivierten Funktionen.",
      ],
    },
    {
      h: "5.2 Zweck der Verarbeitung",
      sub: true,
      items: [
        "Die Verarbeitung erfolgt zu folgenden Zwecken:",
        [
          "Verwaltung und Zuordnung der Kinderprofile",
          "Organisation und Dokumentation der Kursteilnahme",
          "Erfassung und Darstellung des Lernfortschritts",
          "Dokumentation erreichter Schwimmabzeichen",
          "Information der Erziehungsberechtigten über den Entwicklungsstand ihres Kindes",
          "Kommunikation zwischen der Schwimmschule und den Erziehungsberechtigten",
          "Verwaltung des Zahlungsstatus gebuchter Kurse.",
        ],
        "Soweit die Verarbeitung zur Erfüllung des Schwimmkursvertrags erforderlich ist, erfolgt sie auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Für darüber hinausgehende Verarbeitungen muss jeweils eine geeignete Rechtsgrundlage vorliegen.",
      ],
    },
    {
      h: "5.3 Elternkonten und Zugriff auf Kinderprofile",
      sub: true,
      items: [
        "Für die Nutzung der Eltern-App können persönliche Benutzerkonten eingerichtet werden.",
        "Erziehungsberechtigte erhalten Zugriff auf die Kinderprofile, die ihrem jeweiligen Benutzerkonto zugeordnet sind. Sie können die für sie freigegebenen Informationen zu den Kursen und Schwimmfortschritten ihrer Kinder einsehen.",
        "Ein Zugriff auf die Profile anderer Kinder oder anderer Familien ist nicht vorgesehen.",
        "Die Verwaltung der Kinderprofile sowie die Eintragung und Änderung von Anwesenheiten, Fortschrittsnotizen und Schwimmabzeichen erfolgt durch die Schwimmschule beziehungsweise durch hierzu berechtigte Personen.",
        "Die Anmeldung kann über die im jeweiligen System eingerichteten Authentifizierungsverfahren erfolgen. Soweit eine Anmeldung mit einem Einmalcode per E-Mail (OTP) eingesetzt wird, dient dieses Verfahren der Authentifizierung des Benutzerkontos.",
        "Wir treffen angemessene technische und organisatorische Maßnahmen, um unbefugte Zugriffe auf die Benutzerkonten und Kinderprofile zu verhindern. Dazu gehört insbesondere die Beschränkung von Zugriffsrechten auf die jeweils erforderlichen Daten.",
      ],
    },
    {
      h: "5.4 Technischer Betrieb der App durch Emergent",
      sub: true,
      items: [
        "Für die Entwicklung und Bereitstellung der Eltern-App nutzen wir die Plattform Emergent.",
        "Die Plattform stellt Funktionen zur Entwicklung, Bereitstellung und zum technischen Betrieb von Anwendungen zur Verfügung. Nach den Angaben von Emergent werden App-Daten unter anderem über eine MongoDB-Datenbank in einer Cloud-Infrastruktur gespeichert. Emergent gibt als mögliche Verarbeitungs- und Speicherländer die USA und Indien an.",
        "Je nach tatsächlicher technischer Konfiguration können daher personenbezogene Daten, die über die Eltern-App verarbeitet werden, durch Emergent und eingesetzte technische Unterauftragnehmer verarbeitet werden. Dies kann beispielsweise Kinderprofile, Kurszuordnungen, Anwesenheitsdaten und dokumentierte Schwimmfortschritte betreffen.",
        "Eine Verarbeitung personenbezogener Daten außerhalb der Europäischen Union beziehungsweise des Europäischen Wirtschaftsraums ist möglich. Etwaige Drittlandübermittlungen müssen die Anforderungen der Art. 44 ff. DSGVO erfüllen. Dazu gehören gegebenenfalls geeignete Übermittlungsmechanismen und zusätzliche Schutzmaßnahmen.",
        "Vor dem produktiven Einsatz der App prüfen wir die geltenden Datenschutz- und Auftragsverarbeitungsbedingungen, die eingesetzten Unterauftragnehmer sowie die tatsächlich genutzten Speicherorte.",
        "Weitere Informationen von Emergent:",
        [
          "Datenschutzinformationen: https://app.emergent.sh/privacy-policy",
          "Auftragsverarbeitungsbedingungen (Data Processing Agreement): https://app.emergent.sh/dpa",
          "Informationen zu Unterauftragnehmern: https://app.emergent.sh/subprocessors",
        ],
        "Die konkrete technische Konfiguration unserer App ist für die abschließende Beurteilung maßgeblich.",
      ],
    },
    {
      h: "6. Gesundheitsbezogene Angaben",
      items: [
        "Im Zusammenhang mit der Anmeldung oder Durchführung eines Schwimmkurses können Erziehungsberechtigte freiwillig Angaben zu gesundheitlichen Besonderheiten ihres Kindes mitteilen, sofern diese für die sichere Teilnahme am Schwimmkurs relevant sind.",
        "Gesundheitsdaten gehören zu den besonderen Kategorien personenbezogener Daten im Sinne von Art. 9 DSGVO. Sie werden nur verarbeitet, wenn hierfür eine geeignete Rechtsgrundlage besteht und die Verarbeitung für den jeweiligen Zweck erforderlich ist.",
        "Nicht erforderliche Gesundheitsangaben sollten nicht übermittelt werden.",
      ],
    },
    {
      h: "7. Kontaktaufnahme per E-Mail oder WhatsApp",
      items: [
        "Wenn du uns per E-Mail oder WhatsApp kontaktierst, verarbeiten wir die von dir übermittelten personenbezogenen Daten zur Bearbeitung deiner Anfrage und zur Kommunikation mit dir.",
        "Dabei können insbesondere dein Name, deine Kontaktdaten und der Inhalt deiner Nachricht verarbeitet werden.",
        "Rechtsgrundlage ist, soweit die Kommunikation der Durchführung vorvertraglicher Maßnahmen oder eines Vertrags dient, Art. 6 Abs. 1 lit. b DSGVO. In anderen Fällen kann die Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO beruhen, sofern die gesetzlichen Voraussetzungen erfüllt sind.",
        "Bei der Nutzung von WhatsApp können personenbezogene Daten auch durch den jeweiligen Dienstanbieter verarbeitet werden. Bitte beachte hierzu die Datenschutzinformationen des jeweiligen Anbieters.",
      ],
    },
    {
      h: "8. Speicherung und Löschung personenbezogener Daten",
      items: [
        "Wir speichern personenbezogene Daten nur so lange, wie dies für die jeweiligen Verarbeitungszwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.",
        "Nach Wegfall des jeweiligen Zwecks werden die Daten gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten oder andere rechtliche Gründe einer Löschung entgegenstehen.",
        "Für Buchungsdaten, Buchhaltungsunterlagen, Kinderprofile, Lernfortschritte und Benutzerkonten können unterschiedliche Speicherfristen gelten.",
        "Nach Ablauf der jeweils geltenden Fristen werden die Daten gelöscht oder ihre Verarbeitung wird eingeschränkt, soweit dies gesetzlich vorgesehen ist.",
        "Die Speicherung bei externen Dienstleistern richtet sich ergänzend nach den jeweiligen vertraglichen Vereinbarungen und den technischen Löschmöglichkeiten der eingesetzten Systeme.",
      ],
    },
    {
      h: "9. Cookies und vergleichbare Technologien",
      items: [
        "Unsere Website kann Cookies und vergleichbare Technologien verwenden, um technisch erforderliche Funktionen bereitzustellen und die Nutzung der Website zu ermöglichen.",
        "Soweit nicht technisch erforderliche Cookies oder vergleichbare Technologien eingesetzt werden, erfolgt dies nur auf Grundlage der gesetzlich erforderlichen Einwilligung.",
        "Eine erteilte Einwilligung kann über die entsprechenden Einstellungen widerrufen werden. Zusätzlich können Cookies über die Einstellungen des verwendeten Browsers eingeschränkt oder gelöscht werden. Dies kann die Funktionalität der Website beeinträchtigen.",
        "Die tatsächlich eingesetzten Cookies und Technologien hängen von der technischen Konfiguration unserer Website und den eingebundenen Diensten ab.",
      ],
    },
    {
      h: "10. Weitergabe von Daten und externe Dienstleister",
      items: [
        "Wir geben personenbezogene Daten nur weiter, wenn dies für die Erbringung unserer Leistungen erforderlich ist, eine gesetzliche Verpflichtung besteht oder eine andere geeignete datenschutzrechtliche Grundlage vorliegt.",
        "Zu den im Rahmen unserer Leistungen eingesetzten beziehungsweise eingesetzten technischen Dienstleistern gehören insbesondere:",
        [
          "YOLAWO: Online-Buchungen und Kursanmeldungen",
          "Emergent: Entwicklung und Bereitstellung der Eltern-App",
          "weitere technische Dienstleister: gegebenenfalls Hosting, Datenbankbetrieb, E-Mail-Versand, Authentifizierung und technische Wartung.",
        ],
        "Ob und welche weiteren Anbieter personenbezogene Daten erhalten, hängt von der konkreten technischen Konfiguration der Website und der Eltern-App ab.",
        "Soweit externe Dienstleister personenbezogene Daten in unserem Auftrag verarbeiten, schließen wir die gesetzlich erforderlichen Vereinbarungen zur Auftragsverarbeitung ab.",
      ],
    },
    {
      h: "11. Rechte betroffener Personen",
      items: [
        "Du hast im Rahmen der gesetzlichen Voraussetzungen insbesondere folgende Rechte:",
        [
          "Auskunft über deine personenbezogenen Daten gemäß Art. 15 DSGVO",
          "Berichtigung unrichtiger Daten gemäß Art. 16 DSGVO",
          "Löschung deiner Daten gemäß Art. 17 DSGVO",
          "Einschränkung der Verarbeitung gemäß Art. 18 DSGVO",
          "Datenübertragbarkeit gemäß Art. 20 DSGVO",
          "Widerspruch gegen bestimmte Verarbeitungen gemäß Art. 21 DSGVO.",
        ],
        "Soweit eine Verarbeitung auf einer Einwilligung beruht, kannst du diese jederzeit mit Wirkung für die Zukunft widerrufen.",
        "Zur Ausübung deiner Rechte kannst du dich an folgende E-Mail-Adresse wenden:\ninfo@schwimmschulemanta.de",
        "Bitte beachte, dass die Rechte und deren Umfang von der jeweiligen Rechtsgrundlage und den gesetzlichen Voraussetzungen abhängen.",
      ],
    },
    {
      h: "12. Beschwerderecht bei einer Datenschutzaufsichtsbehörde",
      items: [
        "Du hast das Recht, dich bei einer Datenschutzaufsichtsbehörde zu beschweren, wenn du der Ansicht bist, dass die Verarbeitung deiner personenbezogenen Daten gegen die DSGVO verstößt.",
      ],
    },
    {
      h: "13. Datenschutz von Kindern",
      items: [
        "Da unsere Schwimmkurse überwiegend von Kindern besucht werden, achten wir besonders auf den Schutz ihrer personenbezogenen Daten.",
        "Die Verarbeitung der Daten erfolgt zweckgebunden und beschränkt auf den erforderlichen Umfang. Der Zugriff auf Kinderprofile in der Eltern-App ist auf die jeweils zugeordneten Benutzerkonten beschränkt.",
        "Erziehungsberechtigte sollten ihre Zugangsdaten vertraulich behandeln und den Zugriff durch unbefugte Personen verhindern.",
        "Gesundheitsbezogene Angaben werden nur verarbeitet, wenn eine geeignete Rechtsgrundlage besteht und die Verarbeitung für den jeweiligen Zweck erforderlich ist.",
      ],
    },
    {
      h: "14. Aktualität dieser Datenschutzerklärung",
      items: [
        "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich unsere Datenverarbeitungen, die eingesetzten technischen Systeme oder die gesetzlichen Anforderungen ändern.",
        "Stand: Oktober 2026",
      ],
    },
  ],
};
